import React from 'react';
import Sidebar from '../components/Sidebar';
import './MainLayout.css';

function MainLayout({ children }) {
  return (
    <div className="main-layout">
      <Sidebar />
      <main className="main-content">
        {children} {/* Aquí se renderizará el contenido de la página activa */}
      </main>
    </div>
  );
}

export default MainLayout; 